import { Box } from '@mui/material';
import React from 'react';
import { shape, bool, object, string } from 'prop-types';
import Modal from '../Modal';
import connector from './connector';

const VideoModal = ({ isOpen, actions, src = null }) => {
  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={actions.videoModal.close}>
      <Box
        component="video"
        controls
        sx={{
          width: '100%',
          maxWidth: window.innerWidth - 100,
          maxHeight: window.innerHeight - 100,
        }}
      >
        <source src={src} type="video/mp4" />
      </Box>
    </Modal>
  );
};
VideoModal.propTypes = {
  src: string,
  isOpen: bool.isRequired,
  actions: shape({
    videoModal: object.isRequired,
  }).isRequired,
};

export default connector(VideoModal);
